import { arrayToMap, arrayToCategorizedMap, mapObject } from "../util";
import { conversionCityMap } from "../cityConversion";

export const injects = ['pref']

export const path = "/master/common";

export const handler = (data, masterData) => {
  const byPref = arrayToCategorizedMap(data.cities, "pref");
  const byPrefAndSlug = mapObject(byPref, cities => arrayToMap(cities, "slug"));
  for (const pref of masterData.pref.list) {
    byPrefAndSlug[pref.prefId] = byPrefAndSlug[pref.prefId] || {};
  }
  // baseSlugを計算する
  for (const city of data.cities) {
    if (conversionCityMap[city.name]) {
      Object.assign(city, conversionCityMap[city.name]);
    }
    if (city.districtSlug) {
      if (city.slug.endsWith(city.districtSlug)) {
        city.baseSlug = city.slug.slice(0, -city.districtSlug.length);
        const baseCity = byPrefAndSlug[city.pref][city.baseSlug];
        city.districtName = city.name.slice(baseCity.name.length)
      } else {
        city.dirty = true;
      }
    }
  }
  return {
    list: data.cities,
    byPref,
    byPrefAndSlug,
  };
};



// WEBPACK FOOTER //
// ./lib/masterData/schemas/city.js